import Vue, { CreateElement } from 'vue'
import { Component } from '@niknevis/vue-modules'
import QIcon from 'quasar/src/components/icon/QIcon.js';

const staticClass = 'q-table__bottom row items-center'

export interface TesTableBottom {
  [key: string]: any
}

@Component
export class TesTableBottom extends Vue {
  __getNoData(h: CreateElement) {

    if (this.loading) {
      return () => {
        return h('div', {
          staticClass: 'full-width row items-center justify-center q-gutter-sm'
        }, [
          h('span', {
            staticClass: 'text-tes-navy-blue-dark'
          }, ['در حال دریافت اطلاعات از سرور...'])
        ])
      }
    }
    return this.$scopedSlots['no-data']
      ? this.$scopedSlots['no-data']
      : () => {
        return h('div', {
          staticClass: 'full-width row items-center justify-center q-gutter-sm'
        }, [
          h(QIcon, {
            props: {
              color: 'tes-grey-dark',
              size: 'sm',
              name: 'ion warning'
            }
          }),
          h('span', {
            staticClass: 'text-tes-navy-blue-dark'
          }, ['آیتمی یافت نشد'])
        ])
      }
  }

  __getBottomDiv(h) {
    if (this.hideBottom === true) {
      return
    }

    if (this.nothingToDisplay === true) {
      if (this.hideNoData === true) {
        return
      }

      const message = this.loading === true
        ? this.loadingLabel || this.$q.lang.table.loading
        : (this.filter ? this.noResultsLabel || this.$q.lang.table.noResults : this.noDataLabel || this.$q.lang.table.noData)

      const noData = this.__getNoData(h)

      const children = noData !== void 0
        ? [noData({ message, icon: this.$q.iconSet.table.warning, filter: this.filter })]
        : [
          h(QIcon, {
            staticClass: 'q-table__bottom-nodata-icon',
            props: { name: this.$q.iconSet.table.warning }
          }),
          message
        ]

      return h('div', {
        staticClass: staticClass + ' q-table__bottom--nodata'
      }, children)
    }

    const bottom = this.$scopedSlots.bottom

    if (bottom !== void 0) {
      return h('div', { staticClass }, [bottom(this.marginalsScope)])
    }

    const child = this.hideSelectedBanner !== true && this.hasSelectionMode === true && this.rowsSelectedNumber > 0
      ? [
        h('div', { staticClass: 'q-table__control' }, [
          h('div', [
            (this.selectedRowsLabel || this.$q.lang.table.selectedRecords)(this.rowsSelectedNumber)
          ])
        ])
      ]
      : []

    if (child.length > 0) {
      return h('div', { staticClass }, child)
    }
  }
}
